<template>
  <div class="layout-login__body" ref="$currentComponentWrapper">
    <RouterLink to="/login" class="layout-login__back-link"
      ><ArrowLeftIcon></ArrowLeftIcon>
      Назад
    </RouterLink>
    <div
      class="layout-login__state-desc"
      v-if="$route.path == '/restore-success'"
    >
      Восстановление доступа
    </div>
    <div class="layout-login__wrap-input">
      <div class="layout-login__desc-input">Восстановление доступа</div>
      <TirPmInput
        type="email"
        isAutocomplete
        label="Электронная почта"
        placeholder=""
        @input="onInput"
        is-show-hint
        v-model="login"
        :isWithError="showError"
      >
        <template #leftInputAddons>
          <div class="layout-login__input-addons">
            <UserIcon></UserIcon>
          </div>
        </template>
        <template #hintMessage
          ><span v-if="!showError"
            >Введите ваш адрес электронной почты, который был указан при
            авторизации</span
          >
          <span v-if="showError">{{ errorMessage }}</span>
        </template>
      </TirPmInput>
    </div>
  </div>
</template>

<script lang="ts" setup>
import AuthLayout from "@/layouts/AuthLayout.vue";
import { UserIcon, ArrowLeftIcon } from "tir-style-system/icons/outline";
import { TirPmInput } from "tir-pm-input";
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
} from "tir-pm-button";
import { TirDivider } from "tir-pm-divider";
import { computed, onMounted, ref } from "vue";
import { useRouter } from "vue-router";

onMounted(() => {});

const login = ref("");

const router = useRouter();

import ApiService from "@/shared/api";
import { EmailValidation } from "@/tir-pm-validation";

const showError = ref(false);
const errorMessage = ref("");

/**
 * Лоадер для кнопки
 */
const loadingRequest = ref(false);

/**
 * Перерасчет высоты
 */
const loadingRequestComputed = computed(() => {
  return loadingRequest.value;
});

const api = new ApiService();

const onInput = () => {
  showError.value = false;
  updateHeight();
};

const updateHeight = () => {
  setTimeout(() => {
    currentHeightComponent.value = $currentComponentWrapper.value?.offsetHeight;
    console.log(currentHeightComponent.value);
  });
};

const onRestoreAccess = () => {
  loadingRequest.value = true
  let testEmail = EmailValidation(login.value);
  if (testEmail.IsSuccess) {
    api.Main.UsersService.resetPasswordGetTokenAsync({ Email: login.value })
      .then((data) => {
        if (data.ErrorMessage) {
          console.log(data.ErrorMessage);
          showError.value = true;
          errorMessage.value = data.ErrorMessage;
        } else {
          router.push(`/restore-done/${login.value}`);
          showError.value = false;
        }
      })
      .catch((err) => {
        showError.value = true;
        errorMessage.value = err.ErrorMessage;
      });
  } else {
    showError.value = true;
    errorMessage.value = testEmail.Message;
  }
  loadingRequest.value = false
  updateHeight();
};

const $currentComponentWrapper = ref(null);
const currentHeightComponent = ref(0);

const currentHeightLocalComputed = computed(() => {
  return currentHeightComponent.value;
});

onMounted(() => {
  currentHeightComponent.value = $currentComponentWrapper.value?.offsetHeight;
});

defineExpose({
  changerMethodFromComponent: onRestoreAccess,
  currentHeightComponent: currentHeightLocalComputed,
  isLoadingIntoComponent: loadingRequestComputed,
});
</script>
